module.exports = __webpack_public_path__ + "static/binance-5f1eea6c4d2ae1f2883f2228d539ff3f.jpg";